/**
 * Used for exhaustive type checking. In newer versions of TypeScript, this can
 * be replaced by `value satisfies never`.
 */
export function assertNever(value: never): never {
  throw new Error(`Got value that should never have occurred, but was ${JSON.stringify(value)}`)
}

export function assertPropertyIsNotNull<T, P extends keyof T>(
  obj: T,
  property: P,
): asserts obj is T & { [K in P]: NonNullable<T[K]> } {
  const value = obj[property]
  if (value == null) {
    throw new Error(`Expected ${String(property)} to be non-null, but was null`)
  }
}
